var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonStoryBanner.jinja');
require('./CommonStoryBanner.less');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonStory/CommonStoryBanner.js
// module id = 90
// module chunks = 0